module.exports = __webpack_public_path__ + "img/Picture10.76f9a93f.png";